import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-wareneinsatz',
    templateUrl: './wareneinsatz.component.html',
    styleUrls: ['./wareneinsatz.component.css'],
})
export class WareneinsatzComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
